import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';

interface ReportModalProps {
  open: boolean;
  type: string;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

const ReportModal: React.FC<ReportModalProps> = ({
  open,
  type,
  onClose,
  onConfirm,
}) => {
  // State
  const [reason, setReason] = useState<string>('');

  return (
    <div>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Report this {type}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please let us know why you&apos;re reporting this {type}.
            <br />
            Our team will review and rectify the issue.
          </DialogContentText>
          <TextField
            required
            fullWidth
            multiline
            rows={2}
            id="reason"
            label="Reason"
            type="text"
            placeholder="Type here..."
            onChange={(event) => setReason(event.currentTarget.value)}
            sx={{
              marginTop: '10px',
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button color="inherit" onClick={onClose}>
            Cancel
          </Button>
          <Button
            color="primary"
            disabled={reason.length < 4}
            onClick={() => onConfirm(reason)}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ReportModal;
